<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت صفحه اصلی</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                  <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md6 lg6 xl6 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    <v-text-field outlined dense label="تلفن" v-model="phone"></v-text-field>
                                    <v-text-field outlined dense label="فکس" v-model="fax"></v-text-field>
                                    <v-text-field outlined dense label="پست الکترونیکی" v-model="email"></v-text-field>
                                    <v-textarea outlined dense label="آدرس" v-model="address"></v-textarea>
                                    <v-file-input
                                            counter
                                            label="Select Favicon"
                                            show-size
                                            light
                                            style="direction:ltr"
                                            outlined dense
                                            truncate-length="41"
                                            accept="image/ico"
                                            @change="uploadFavicon($event)"
                                            ></v-file-input>
                                    

                                    <v-btn @click="registerCategory" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                              
                                </v-flex>
                                <v-flex xs12 sm12 md6 lg6 xl6 style="padding:15px;padding-top:0px !important"><!--Seo Form-->
                                    <seo-form FileLoc="CONTENTSEO" :Seo="SeoData" @SeoData="SeoChanged"></seo-form>
                                    <v-divider></v-divider>
                                    <div style="padding-top:10px;padding-bottom:10px;font-weight:bolder">تنظیمات بخش خبرنامه</div>
                                        <v-row>
                                            <v-col cols="6"><v-text-field outlined dense label="عنوان" v-model="NletterTitle"></v-text-field></v-col>
                                            <v-col cols="6"><v-text-field outlined dense label="متن" v-model="NletterText"></v-text-field></v-col>
                                        </v-row>
                                    
                                </v-flex>

                             
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
       <!-- <template>
           <v-dialog max-width="300px" v-model="ColorPickerDialog">
               <v-card>
                   <v-card-text style="padding-top:20px">
                       <v-color-picker v-model="NletterColor"></v-color-picker>
                       <div style="padding-top:20px">
                           <v-text-field outlined dense label="رنگ" v-model="NletterColor"></v-text-field>
                       </div>
                   </v-card-text>
               </v-card>
           </v-dialog>
       </template> -->
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
    </div>
</template>

<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import { mapState, mapMutations, mapActions } from 'vuex'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VueEditor } from "vue2-editor";
export default {
    name:"indexseo",
   components: {
            Loading,
            VueEditor
        },
    data:()=> ({
        CurrentPageName:"IndexSeo",
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        SeoData:{title:"",image:"",url:"",keywords:"",othermeta:"",description:""},
        seo:"",
        ALLOEWDIMGSIZE:{},
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        EditorContent:"",
        ico:"",
        iconUrl:"",
        phone:"",
        fax:"",
        email:"",
        address:"",
        ColorPickerDialog:false,
        uploadServiceUrl:"",
        NletterText:"",
        NletterTitle:"",
        FooterLogos:[
            {title:"",sort:1,image:"",status:false}
        ]
    }),
    async created()
    {
        let vm = this;
        vm.uploadServiceUrl = ApiUrl.registerPcImg;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadCategories();
        }
    },
    methods:{
        async uploadFavicon(e)
        {
            
            let vm = this;
            var data = new FormData();
            data.append("File",e);
            vm.inUploading = true;
            await axios.post(ApiUrl.uploadIndexSections+'/NONE',data)
                .then(function (res) {
                    console.log(res);
                    vm.inUploading = false;
                    if(res.data.status)
                    {
                        vm.iconUrl = res.data.data;
                        MSGHNDL.OK("فایل  با موفقیت آپلود شد");
                 
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },
        ...mapActions([                  // Add this
        'setSeoForm'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.seo;
           
        },
        async loadCategories()
        {
            let vm = this;
            vm.EditorContent = "";
            vm.SeoData = {};
            vm.phone = "";
            vm.fax = "";
            vm.email = "";
            vm.address = "";
            vm.iconUrl = "";
            vm.isLoadingCats = true;
            let Model ={};
            Model.PageName = vm.CurrentPageName;
            Model.Lang = vm.LANG;
            await axios.post(ApiUrl.GetPageContent,Model).then(async (res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn("DATTTTTTTTTTTTA",data);
                if(data.status)
                {
                    vm.EditorContent = data.data.pageContent;
                     vm.SeoData = (JSON.parse(data.data.pageSeo)); 
                     let d = JSON.parse(data.data.pageOtherSetting);
                     vm.iconUrl = d.icon;
                     vm.phone = d.phone;
                     vm.fax = d.fax;
                     vm.email = d.email;
                     vm.address = d.address;
                     let nl = d.Newsletter;
                     vm.NletterTitle = nl.title;
                     vm.NletterText = nl.text;
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async registerCategory()
        {
            let vm = this;
            let Model = {};
            Model.PageName = vm.CurrentPageName;
            Model.PageId = vm.seo.url;
            Model.PageSeo = JSON.stringify(vm.seo);
            var os = {};
            os.icon = vm.iconUrl;
            os.phone = vm.phone;
            os.fax = vm.fax;
            os.email = vm.email;
            os.address = vm.address;
            var nletter = {};
            nletter.title = vm.NletterTitle;
            nletter.text = vm.NletterText;
            os.Newsletter = nletter;
           
            Model.PageOtherSetting = JSON.stringify(os);
            Model.Lang = vm.LANG;
            await axios.post(ApiUrl.AddPageContent,Model).then(async (res)=>{
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.loadCategories();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        },
        SeoChanged(data)
        {
            this.seo = data;
        }
    }
}
</script>